import { Textarea as NextUITextarea, TextAreaProps } from '@nextui-org/react';

export function Textarea(props: TextAreaProps) {
  return (
    <NextUITextarea
      classNames={{
        inputWrapper: [
          'bg-white',
          'shadow-none',
          'border-2',
          props.isDisabled ? 'border-default' : 'border-primary',
        ],
      }}
      {...props}
    >
      {props.children}
    </NextUITextarea>
  );
}
